const pt = {
    '/': {
        title: '{brand} e Apostas Esportivas | Saques Cripto Instantâneos',
        description: '{brand} e apostas esportivas na mesma carteira. Slots, cassino ao vivo e jogos provably fair, com saques em cripto instantâneos.',
        keywords: 'cassino crypto, cassino bitcoin, apostas esportivas cripto, slots crypto, saque instantâneo, cassino provably fair'
    },
    '/casino': {
        title: 'Cassino Online | Caça-Níqueis, Blackjack & Dealers ao Vivo | {brand}',
        description: 'Caça-níqueis, blackjack, roleta & dealers ao vivo no {brand}. Centenas de jogos, depósitos crypto rápidos & saques instantâneos disponíveis 24/7.',
        keywords: 'cassino crypto, jogos de cassino bitcoin, cassino online, slots crypto, cassino ao vivo, blackjack, roleta'
    },
    '/sports': {
        title: 'Apostas Esportivas Online | Apostas Crypto & Odds | {brand}',
        description: 'Aposte em esportes no {brand}. Odds competitivas em futebol, basquete & mais. Apostas ao vivo, apostas crypto seguras & pagamentos rápidos.',
        keywords: 'apostas esportivas cripto, casa de apostas bitcoin, apostas ao vivo, odds de futebol, apostas esports'
    },
    '/livecasino': {
        title: 'Cassino ao Vivo | Blackjack, Roleta & Dealers ao Vivo | {brand}',
        description: 'Blackjack, roleta & jogos de cassino ao vivo no {brand}. Dealers reais, streaming em HD & ampla seleção de mesas ao vivo disponíveis 24/7.',
        keywords: 'cassino ao vivo, dealers ao vivo, blackjack ao vivo, roleta ao vivo, bacará ao vivo, game shows'
    },
    '/slots': {
        title: 'Caça-Níqueis Online | Grande Variedade de Slots de Cassino | {brand}',
        description: 'Uma enorme coleção de caça-níqueis no {brand}. Máquinas clássicas, vídeo slots & progressivas, todas jogáveis com crypto.',
        keywords: 'slots crypto, slots bitcoin, caça-níqueis online, video slots, slots megaways, compra de bônus'
    },
    '/vip': {
        title: 'Programa VIP | Recompensas Exclusivas & Benefícios | {brand}',
        description: 'O programa VIP do {brand}: recompensas exclusivas, bônus personalizados & suporte prioritário. Vantagens sob medida para jogadores fiéis.',
        keywords: 'programa vip cassino, rakeback, recompensas de fidelidade, cassino high roller, níveis vip'
    },
    '/welcome-offer': {
        title: 'Oferta de Boas-Vindas | Cassino Crypto | {brand}',
        description: 'Reivindique o bônus de boas-vindas do {brand} no seu primeiro depósito. Saiba como começar e aproveite ao máximo nossa oferta de cadastro.',
        keywords: 'bônus de boas-vindas cassino, bônus cassino cripto, bônus primeiro depósito, oferta novos jogadores'
    },
    '/referral': {
        title: 'Programa de Indicação | Convide Amigos & Ganhe Recompensas | {brand}',
        description: 'Indique amigos ao {brand} & ganhe recompensas quando eles se cadastrarem e jogarem. Compartilhe seu link e colete bônus por cada indicação.',
        keywords: 'programa de indicação cassino, bônus indique um amigo, recompensas de afiliados'
    },
    '/promotion-page': {
        title: 'Promoções do Cassino | Bônus & Ofertas Especiais | {brand}',
        description: 'Confira as últimas promoções do {brand}. Bônus atuais, torneios & eventos especiais - resgate sua oferta e comece a jogar.',
        keywords: 'promoções de cassino, bônus cassino cripto, corrida semanal, torneios de cassino'
    },
    '/featurebuyin': {
        title: 'Slots com Feature Buy-In | Pule para os Rodadas Bônus | {brand}',
        description: 'Pule direto para as rodadas bônus com os slots de feature buy-in do {brand}. Ative recursos bônus instantaneamente para uma chance de grandes ganhos.'
    },
    '/gameshows': {
        title: 'Game Shows ao Vivo | Jogue Game Shows de Cassino no {brand}',
        description: 'Jogue game shows de cassino ao vivo no {brand}. Aproveite Crazy Time, Monopoly Live & mais, apresentados por dealers profissionais em tempo real.'
    },
    '/newgames': {
        title: 'Novos Jogos de Cassino | Últimos Slots & Jogos Ao Vivo | {brand}',
        description: 'Jogue os jogos de cassino mais recentes no {brand}. Atualizado regularmente com novos slots & jogos de mesa dos melhores provedores. Seja o primeiro a jogar.'
    },
    '/populargames': {
        title: 'Jogos de Cassino Populares | Top Slots & Jogos Ao Vivo | {brand}',
        description: 'Jogue os jogos de cassino mais populares no {brand}. Slots & jogos de mesa mais bem avaliados pela nossa comunidade, disponíveis com crypto.'
    },
    '/hotslots': {
        title: 'Slots em Alta | Caça-Níqueis Mais Jogados | {brand}',
        description: 'Jogue os caça-níqueis mais populares no {brand}. Os slots em alta do momento, todos disponíveis com crypto.'
    },
    '/table_games': {
        title: 'Jogos de Mesa | Blackjack, Roleta & Bacará | {brand}',
        description: 'Jogue blackjack, roleta, bacará e mais jogos de mesa no {brand}. Tudo disponível com crypto.'
    },
    '/hotlive': {
        title: 'Cassino Ao Vivo em Alta | Jogos Ao Vivo Mais Jogados | {brand}',
        description: 'Os jogos de cassino ao vivo mais populares no {brand}. Jogue com dealers reais em tempo real.'
    },
    '/originals': {
        title: 'Jogos Originais de Cassino | Títulos Exclusivos | {brand}',
        description: 'Jogue jogos originais exclusivos no {brand}. Títulos únicos que você não encontrará em nenhum outro lugar, desenvolvidos internamente para uma experiência de cassino incomparável.'
    },
    '/providers': {
        title: 'Provedores de Jogos | Estúdios Parceiros & Software | {brand}',
        description: 'Explore todos os provedores de jogos no {brand}. Fazemos parceria com os melhores estúdios para oferecer uma biblioteca crypto diversificada e de alta qualidade.'
    },
    '/about-us': {
        title: 'Sobre Nós | Saiba Mais Sobre o {brand}',
        description: 'Conheça o {brand}, um cassino crypto & casa de apostas esportivas líder. Comprometidos com apostas seguras, justas & emocionantes com saques instantâneos em crypto.'
    },
    '/affiliate': {
        title: 'Programa de Afiliados | Ganhe Crypto com o {brand}',
        description: 'Faça parceria com o {brand} & ganhe comissões promovendo nosso cassino crypto. Taxas competitivas, rastreamento em tempo real & suporte dedicado para afiliados.'
    },
    '/faq': {
        title: 'FAQ | Perguntas Frequentes | {brand}',
        description: 'Encontre respostas para perguntas comuns sobre o {brand}. Consulte nosso FAQ para ajuda com contas, pagamentos, bônus & jogos de cassino.'
    },
    '/aml-policy': {
        title: 'Política AML | Prevenção à Lavagem de Dinheiro no {brand}',
        description: 'A política AML do {brand} garante um ambiente seguro e confiável. Leia sobre nossas medidas para prevenir atividades ilícitas em nossa plataforma.'
    },
    '/bonus-terms': {
        title: 'Termos e Condições dos Bônus | Promoções do {brand}',
        description: 'Leia as regras dos bônus & promoções do {brand}. Saiba como reivindicar, usar & sacar os ganhos de bônus da nossa plataforma.'
    },
    '/complaints-and-arbitration': {
        title: 'Reclamações e Arbitragem | Suporte ao Jogador no {brand}',
        description: 'Conheça o processo de reclamações & resolução de disputas do {brand}. Garantimos tratamento justo e resolvemos problemas de jogadores de forma rápida e transparente.'
    },
    '/fairness': {
        title: 'Jogos Comprovadamente Justos | Garantia de Justiça no {brand}',
        description: 'O {brand} usa tecnologia provably fair para garantir que cada resultado de jogo seja verificável, transparente & completamente aleatório.'
    },
    '/kyc-policy': {
        title: 'Política KYC | Conheça Seu Cliente no {brand}',
        description: 'A política KYC do {brand} descreve nosso processo de verificação de identidade. Saiba como protegemos os jogadores e mantemos um ambiente de jogo seguro.'
    },
    '/payment-policy': {
        title: 'Política de Pagamento | Depósitos & Saques em Crypto | {brand}',
        description: 'O {brand} aceita depósitos & saques em crypto. Leia nossa política de pagamento para limites de transação, moedas aceitas & prazos de processamento.'
    },
    '/privacy-policy': {
        title: 'Política de Privacidade | Proteção de Dados no {brand}',
        description: 'A política de privacidade do {brand}. Saiba como coletamos, usamos & protegemos seus dados pessoais em nossa plataforma de cassino crypto.'
    },
    '/responsible-gaming': {
        title: 'Jogo Responsável | Jogue com Segurança no {brand}',
        description: 'O {brand} está comprometido com o jogo responsável. Acesse ferramentas & recursos para gerenciar seus hábitos de jogo e jogar com segurança.'
    },
    '/terms-of-service': {
        title: 'Termos de Serviço | {brand}',
        description: 'Revise os termos & condições que regem seu uso do {brand}. Entenda seus direitos e responsabilidades como jogador.'
    },
    '/terms-sports': {
        title: 'Termos e Condições de Apostas Esportivas | {brand}',
        description: 'Os termos & condições de apostas esportivas do {brand}. Regras para fazer apostas, pagamentos de ganhos & uso da casa de apostas em nossa plataforma.'
    },
    '/special-bets': {
        title: 'Apostas especiais | Esportivo cripto | {brand}',
        description: 'Faça apostas especiais na {brand}. Mercados de esportes, esports & eventos pontuais, com depósitos cripto instantâneos e pagamentos rápidos.'
    },
    '/transparency': {
        title: 'Transparência | Cassino cripto comprovadamente justo | {brand}',
        description: 'Veja como a {brand} opera de forma aberta. Verificação de justiça comprovável, taxas de retorno publicadas a partir do catálogo ao vivo & pagamentos on-chain.'
    },
    '/faq/about': {
        title: 'Sobre a {brand} | Perguntas frequentes',
        description: 'Sobre a {brand}: licenciamento, como funciona o cassino cripto & o que torna a plataforma justa. Respostas às perguntas mais comuns.'
    },
    '/faq/account': {
        title: 'Conta | Perguntas frequentes | {brand}',
        description: 'Como gerenciar sua conta na {brand}: cadastro, login, verificação & configurações de perfil. Respostas às dúvidas mais comuns sobre a conta.'
    },
    '/faq/bonuses': {
        title: 'Bônus | Perguntas frequentes | {brand}',
        description: 'Os bônus da {brand} explicados: ofertas de boas-vindas, códigos promocionais, requisitos de apostas & recompensas. Dúvidas comuns respondidas.'
    },
    '/faq/deposits': {
        title: 'Depósitos | Perguntas frequentes | {brand}',
        description: 'Como depositar cripto na {brand}: moedas aceitas, redes, valores mínimos & tempos de confirmação. Dúvidas comuns sobre depósitos respondidas.'
    },
    '/faq/games-sports': {
        title: 'Jogos & esportes | Perguntas frequentes | {brand}',
        description: 'Jogos de cassino & apostas esportivas na {brand}: provedores, justiça comprovável, odds & apostas ao vivo. Dúvidas comuns respondidas.'
    },
    '/faq/responsible-gambling': {
        title: 'Jogo responsável | Perguntas frequentes | {brand}',
        description: 'Jogo responsável na {brand}: limites de depósito, autoexclusão, períodos de pausa & ferramentas de apoio para jogar com segurança.'
    },
    '/faq/security': {
        title: 'Segurança | Perguntas frequentes | {brand}',
        description: 'Segurança na {brand}: proteção da conta, autenticação de dois fatores, justiça & privacidade de dados. Dúvidas comuns respondidas.'
    },
    '/faq/support-disputes': {
        title: 'Suporte & disputas | Perguntas frequentes | {brand}',
        description: 'Como obter ajuda na {brand}: chat ao vivo, tempos de resposta & como as disputas são resolvidas. Dúvidas comuns respondidas.'
    },
    '/faq/withdrawals': {
        title: 'Saques | Perguntas frequentes | {brand}',
        description: 'Como sacar cripto da {brand}: prazos de pagamento, valores mínimos, taxas & limites. Respostas às dúvidas mais comuns sobre saques.'
    }
};
export default pt;
